<div>
  <img
    class="float-right"
    src="assets/images/icons/default_icons/icon-close.png"
    alt="icon-close"
    (click)="OnClose()"
    [ngStyle]="{ cursor: 'pointer' }"
  />
</div>
<mat-dialog-content>
  <div *ngIf="data.popUp === 'interview'">
    <h4>Interview Details</h4>

    <mat-tab-group>
      <mat-tab label="Source Active" id="activeSource">
        <mat-card-content>
          <div class="container-fluid padT32" *ngIf="activeSource?.length !== 0">
            <div class="example-table-container">
              <table
                mat-table
                [dataSource]="activeTableSource"
                aria-describedby="mytabledesc"
                aria-describedby="mytabledesc"
                id="activeSourceTbleId"
              >
                <ng-container [matColumnDef]="column" *ngFor="let column of columnDefs">
                  <th id="activeColumns" mat-header-cell *matHeaderCellDef>{{ column }}</th>
                  <td id="{{ element[column] }}" mat-cell *matCellDef="let element">
                    <span
                      *ngIf="column === 'Application ID'"
                      style="cursor: pointer"
                      class="active-txt"
                      (click)="redirect(element[column])"
                      >{{ element[column] || '-' }}</span
                    >
                    <span *ngIf="column !== 'Application ID'">{{ element[column] || '-' }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
                <tr mat-row *matRowDef="let row; columns: columnDefs"></tr>
              </table>
            </div>
          </div>

          <div *ngIf="activeSource?.length === 0" class="customCard nomarT">
            <div class="col-4 offset-4 marTB8 noData">
              <h5 class="H5Header marL16 marT32 center"><strong name="nodata">No data available</strong></h5>
            </div>
          </div>
        </mat-card-content>
      </mat-tab>

      <mat-tab label="Source Expired" id="expiredSource">
        <mat-card-content>
          <div class="container-fluid padT32" *ngIf="expiredSource?.length !== 0">
            <div class="example-table-container">
              <table
                mat-table
                [dataSource]="expiredTableSource"
                aria-describedby="mytabledesc"
                aria-describedby="mytabledesc"
                id="expiredSourceTbleId"
              >
                <ng-container [matColumnDef]="column" *ngFor="let column of columnDefs">
                  <th id="expColumns" mat-header-cell *matHeaderCellDef>{{ column }}</th>
                  <td id="{{ element[column] }}" mat-cell *matCellDef="let element">
                    <span
                      *ngIf="column === 'Application ID'"
                      style="cursor: pointer"
                      class="active-txt"
                      (click)="redirect(element[column])"
                      >{{ element[column] || '-' }}</span
                    >
                    <span *ngIf="column !== 'Application ID'">{{ element[column] || '-' }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
                <tr mat-row *matRowDef="let row; columns: columnDefs"></tr>
              </table>
            </div>
          </div>

          <div *ngIf="expiredSource?.length === 0" class="customCard nomarT">
            <div class="col-4 offset-4 marTB8 noData">
              <h5 class="H5Header marL16 marT32 center"><strong name="nodata">No data available</strong></h5>
            </div>
          </div>
        </mat-card-content>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div *ngIf="data.popUp === 'profile'">
    <h4>Candidate Gallery</h4>
    <br />
    <div *ngIf="!pfError">
      <table
        mat-table
        [dataSource]="profileHistory"
        aria-describedby="pfhstryTable"
        id="pfhstryTbl"
        aria-describedby="pfhstryTable"
      >
        <span *ngFor="let column of columnDefs; let i = index">
          <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Image'">
            <th id="columnHeaderPH{{ column }}" mat-header-cell *matHeaderCellDef>{{ column }}</th>
            <td id="columndataPH{{ column }}" mat-cell *matCellDef="let element; let i = index">
              <div class="dashedBox">
                <img
                  [src]="element['imgURL']"
                  alt="pfPic"
                  style="width: 100%; height: 100%; object-fit: cover; object-position: top center"
                  alt="image"
                />
                <input #file type="file" accept="image/*" hidden />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column }}" *ngIf="column === 'icon'">
            <th id="attachIconHeaderPH" mat-header-cell *matHeaderCellDef class="width3">
              <img
                id="attachImgHeaderPH{{ i }}"
                src="assets/images/icons/default_icons/icon-attachment.png"
                alt="icon-attachment"
                class="pointer"
                width="20px"
                height="20px"
              />
            </th>
            <td id="attachmntdataPH" class="width3" mat-cell *matCellDef="let row" style="cursor: pointer">
              <a (click)="downloadProfilePic(row)">
                <img
                  id="attachImgColumn{{ i }}"
                  src="assets/images/icons/default_icons/icon-attachment.png"
                  alt="icon-attachment"
                  class="pointer"
                  width="20px"
                  height="20px"
                />
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column }}" *ngIf="column === 'File Name'">
            <th id="columnHeaderPH{{ column }}" mat-header-cell *matHeaderCellDef>{{ column }}</th>
            <td id="columndatPH{{ column }}" mat-cell *matCellDef="let element; let i = index">
              {{ element['fileName'] }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Created on'">
            <th id="columnHeaderPH{{ column }}" mat-header-cell *matHeaderCellDef>{{ column }}</th>
            <td id="columndatPH{{ column }}" mat-cell *matCellDef="let element; let i = index">
              {{ element['dateTimeforFileId'] | date }}
            </td>
          </ng-container>
        </span>
        <tr mat-header-row *matHeaderRowDef="columnDefs; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnDefs" class="mat-elevation-z1 tr_bottom"></tr>
      </table>
    </div>
    <div class="col-4 offset-4 marTB8 noData" *ngIf="pfError">
      <h5 class="H5Header marL16 marT32 center">
        <strong name="nodataErr">{{ pfError }}</strong>
      </h5>
    </div>
  </div>
  <div *ngIf="applnStatusResp && data.popUp === 'applnStatus'">
    <mat-list>
      <h4>Background Verification Status</h4>
      <hr />
      <table aria-describedby="appln status">
        <tr>
          <th></th>
          <th>Status</th>
          <th>Comments</th>
        </tr>
        <tr>
          <td><b>BGV</b></td>
          <td>{{ this.applnStatusResp.bgvStatus }}</td>
          <td>
            <span matTooltip="{{ applnStatusResp.bgvComment }}" class="truncate-text">
              {{ this.applnStatusResp.bgvComment }}
            </span>
          </td>
        </tr>
        <tr>
          <td><b>UAN</b></td>
          <td>{{ this.applnStatusResp.uanStatus }}</td>
          <td>
            <span matTooltip="{{ applnStatusResp.uanComment }}" class="truncate-text">
              {{ this.applnStatusResp.uanComment }}
            </span>
          </td>
        </tr>
      </table>
    </mat-list>
  </div>
</mat-dialog-content>
